import { EmptystateKeyColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";

const UserPersonalApiKeysEmpty = () => {
  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState title="User doesn’t have any Personal API keys yet" icon={EmptystateKeyColored} />
    </Box>
  );
};

export default UserPersonalApiKeysEmpty;
